import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postCustomer = async ({
  type,
  pricingCategory,
  title,
  firstName,
  preferredName,
  lastName,
  email,
  mobileNumber,
  phoneNumber,
  secondaryContact,
  secondaryMobileNumber,
  secondaryFirstName,
  secondaryLastName,
  abn,
  billTo,
  companyName,
  homeAddressLine1,
  homeAddressLine2,
  homeAddressSuburb,
  homeAddressState,
  homeAddressPostcode,
  sameBillingAddress,
  postalAddressLine1,
  postalAddressLine2,
  postalAddressSuburb,
  postalAddressState,
  postalAddressPostcode,
  hearAboutUs,
  accessNotes,
  specialNotes,
  searchId,
  marketing,
}: JsonDataItem) => {
  const { data } = await baseQuery('customer-create', {
    type: 'POST',
    body: {
      type,
      default_category: pricingCategory,
      search_history_id: searchId,

      title,
      first_name: firstName,
      preferred_name: preferredName,
      last_name: lastName,
      email,
      mobile_number: mobileNumber,
      phone: phoneNumber,

      second_contact: secondaryContact,
      contact2_first_name: secondaryFirstName,
      contact2_last_name: secondaryLastName,
      contact2_mobile_number: secondaryMobileNumber,
      billto_ID: billTo,

      abn,
      company_name: companyName,

      address1: homeAddressLine1,
      address2: homeAddressLine2,
      suburb: homeAddressSuburb,
      postcode: homeAddressPostcode,
      state: homeAddressState,

      same_address: sameBillingAddress,
      postal_address1: postalAddressLine1,
      postal_address2: postalAddressLine2,
      postal_suburb: postalAddressSuburb,
      postal_state: postalAddressState,
      postal_postcode: postalAddressPostcode,

      hear_about_us: hearAboutUs,
      access_notes: accessNotes,
      special_notes: specialNotes,
      marketing,
    },
  });

  return data;
};
